import styled from '@emotion/styled'
import { readableColor } from 'polished'
import type { Color } from '@graphql/generated'

export const Chip = styled.div<{ colour?: Color['hex'] }>`
  position: relative;
  isolation: isolate;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.1rem;
  padding: 0.35em 1.2em;
  min-inline-size: max-content;
  line-height: 1;
  border-radius: 4px;
  transition: transform 120ms ease-out;
  background-color: rgb(var(--color-primary-300));
  overflow: hidden;
  box-shadow: 2px 2px 4px 0 rgb(var(--color-shadow) / 20%);
  font-size: var(--font-text-s);
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.025em;

  a {
    color: rgb(var(--color-background-300));
  }

  ${({ colour }) =>
    colour
      ? `
      a::before,
      a::after {
        position: absolute;
        content: '';
        top: 0;
        bottom: 0;
        width: 7.5%;
        background-color: ${colour};
        z-index: -1;

        @media (prefers-reduced-motion: no-preference) {
          transition: transform 150ms ease-out;
        }
      }

      a::before {
        left: 0;
      }

      a::after {
        right: 0;
      }
  `
      : null};

  a:is(:hover, :focus, [aria-current='true']) {
    text-decoration: dotted underline;
    outline: none;
    ${({ colour }) => colour && `color: ${readableColor(colour)}`};

    &::before,
    &::after {
      transform: scaleX(13);
    }
  }
`
